"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _orderList = _interopRequireDefault(require("./orderList.vue"));
var _makeMethodMange = _interopRequireDefault(require("./makeMethodMange.vue"));
var _orderDetail = _interopRequireDefault(require("./orderDetail.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '消费订单',
  components: {
    orderList: _orderList.default,
    MakeMethodMange: _makeMethodMange.default,
    orderDetail: _orderDetail.default
  },
  data: function data() {
    return {
      activeName: 'dish',
      editTabs: [],
      tabIndex: 0,
      userId: this.$route.query.userId // 直接从路由参数获取userId
    };
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.query.userId !== from.query.userId) {
        this.userId = to.query.userId;
      }
    }
  },
  methods: {
    handleTabClick: function handleTabClick() {},
    handleOpenEdit: function handleOpenEdit(payload) {
      var id = payload.id,
        title = payload.title;
      // 检查是否已存在同一个 orderId 的标签页
      var existingTab = this.editTabs.find(function (t) {
        return t.orderId === id;
      });
      if (existingTab) {
        // 如果已存在，直接切换到该标签页
        this.activeName = existingTab.name;
        return;
      }
      // 否则创建新标签页
      var name = "edit-".concat(++this.tabIndex);
      this.editTabs.push({
        name: name,
        title: title || '订单详情',
        orderId: id,
        type: 'edit'
      });
      this.activeName = name;
    },
    handleOpenAdd: function handleOpenAdd() {
      var name = "add-".concat(++this.tabIndex);
      this.editTabs.push({
        name: name,
        title: '新增菜品',
        goodsId: null,
        type: 'add'
      });
      this.activeName = name;
    },
    closeEditTab: function closeEditTab(name, refreshed) {
      var tabs = this.editTabs;
      var active = this.activeName;
      if (active === name) {
        var idx = tabs.findIndex(function (t) {
          return t.name === name;
        });
        var next = tabs[idx + 1] || tabs[idx - 1];
        active = next ? next.name : 'dish';
      }
      this.activeName = active;
      this.editTabs = tabs.filter(function (t) {
        return t.name !== name;
      });
      // 让列表页自行刷新（可通过事件或总线实现）。这里简单触发一次自定义事件。
      if (refreshed) this.$emit('refresh-list');
    },
    removeTab: function removeTab(name) {
      this.closeEditTab(name, false);
    }
  }
};